import { createEvent, createStore } from 'effector';

export type HeaderMenuItemValue = {
  title: string;
  path: string;
  dataTestId?: string;
};

export type HeaderMenuItem = HeaderMenuItemValue & {
  items?: HeaderMenuItemValue[];
};

export const setMenu = createEvent<HeaderMenuItem[]>();
export const clearMenu = createEvent();

export const $maniMenu = createStore<HeaderMenuItem[]>([]);

$maniMenu
  .on(setMenu, (_, payload) => {
    return payload;
  })
  .reset(clearMenu);
